// extracted by mini-css-extract-plugin
export default {"link":"MenuLink_link__4nfkZ","link_active":"MenuLink_link_active__4bcnT","link_collapsible":"MenuLink_link_collapsible__nmoVj"};